module.exports = __webpack_public_path__ + "static/media/GrohNamhadod.6d97c562.svg";